/** @type {Styles} */

export const styles = {
  textField: {
    width: '100%',
    '.Mui-disabled': {
      '.MuiSvgIcon-root, .MuiFormLabel-asterisk': { color: 'gray.56' },
    },
  },
  input: {
    padding: 2,
    typography: 'large',
    minHeight: 128,
    color: 'gray.80',
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: 'gray.16',
    },
    '&.Mui-disabled': {
      '&.MuiOutlinedInput-notchedOutline': {
        borderColor: 'gray.16',
        color: 'gray.56',
      },
      'MuiSvgIcon-root': { color: 'gray.56' },
    },
    '.Mui-disabled': {
      WebkitTextFillColor: 'gray.16',
    },
    '.MuiInputAdornment-outlined': {
      marginTop: 0.5,
      marginBottom: 'auto',
      marginX: 'auto',
    },
  },

  errorIcon: {
    color: 'error.main',
    marginBottom: 'auto',
  },
  label: {
    color: 'gray.80',
    typography: 'large',
    '&.Mui-focused': {
      '&.Mui-error': { color: 'error.main' },
    },
    '&.Mui-disabled': {
      color: 'gray.40',
    },
  },
  helperText: {
    '&.Mui-disabled': {
      color: 'gray.64',
    },
  },
  characterCounterContainer: {
    gap: 1.5,
    display: 'flex',
    justifyContent: 'space-between',
    '.MuiTypography-root': {
      display: 'block',
    },
  },
  characterCounter: { whiteSpace: 'nowrap' },
  helperTextDisabled: {
    opacity: 0.6,
  },

  fieldLabelDetached: {
    '& .MuiInputBase-input': {
      border: 1,
      borderColor: 'gray.16',
      borderRadius: 1,
      fontSize: 16,
      padding: 2,
    },
  },
}
